import { render, staticRenderFns } from "./SecretPasswordBody.vue?vue&type=template&id=72a3340d&scoped=true&"
import script from "./SecretPasswordBody.vue?vue&type=script&lang=ts&"
export * from "./SecretPasswordBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3340d",
  null
  
)

export default component.exports